import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import Error from '../../components/Error/Error';

function Offline({ isLoading, match }) {
  return (
    <Layout isLoading={isLoading}>
      <SEO title='Offline' description='You are currently offline.' />

      <Error error='You are currently offline.' link={false} />
    </Layout>
  );
}

Offline.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default Offline;
